import { Box, Button, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';
import { bodyWidth } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';

export const OrderSuccessPage = () => {
  const navigate = useNavigate();

  const { primary, secondary } = useThemeColor();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title='Sipariş Onayı' />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          alignItems: 'center',
          py: 3,
          px: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 120, color: primary }} />

        <Typography sx={{ fontSize: '40px', fontWeight: 600 }}>
          Alışverişiniz için teşekkürler
        </Typography>

        <Typography sx={{ fontSize: '24px' }}>
          Siparişiniz alındı. İlerlemeler mail üzerinden tarafınıza
          iletilecektir.
        </Typography>

        <Button
          onClick={() => navigate('/')}
          variant='contained'
          sx={{
            textTransform: 'none',
            backgroundColor: primary,
            color: secondary,
            mt: 1.5,
          }}
        >
          Alışverişe Devam Et
        </Button>
      </Box>
    </Box>
  );
};
